/**
 * Self-pay entitlement derivation (#359 / #360).
 *
 * Tri-state on purpose:
 *   - `null`  → entitlement UNKNOWN (paywall status still hydrating). Callers
 *               must NOT treat this as "no entitlement" — collapsing it into
 *               `false` is what bounced self-pay drivers back to /onboarding
 *               (jobs 884/887).
 *   - `true`  → the DRIVER pays for their own license and it is usable now.
 *   - `false` → conclusively not a usable self-pay entitlement.
 *
 * A company-funded (company-pay) subscription also resolves to
 * `active`/`trialing`, so the state alone is NOT sufficient: the entitlement
 * only belongs to the driver when the backend reports `is_self_pay === true`.
 * Otherwise the company-pay employment gate decides, not the license.
 */
import type { PaywallStatusResponse } from '../types/paywall';

export function deriveSelfPayEntitlement(
  status: PaywallStatusResponse | null,
  isUnknown: boolean,
): boolean | null {
  if (isUnknown) return null;
  if (!status) return false;
  if (status.is_owner) return false;
  if (status.is_self_pay !== true) return false;
  return status.state === 'trialing' || status.state === 'active';
}
